import { render, staticRenderFns } from "./ReporteAdicionalesExport.vue?vue&type=template&id=45a54556"
import script from "./ReporteAdicionalesExport.vue?vue&type=script&lang=js"
export * from "./ReporteAdicionalesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports